import { connect } from "react-redux";
import EditLob from "./EditLob";
import { bindActionCreators } from "redux";
import { editLob, getLobListing } from "services/redux/Lob/action";

const mapStateToProps = (state) => ({
  lobList: state.lobReducer.lobList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      editLob,
      getLobListing,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EditLob);
